import React from "react";

const NotesIcon = ({
  width = 17,
  height = 17,
  color = "none",
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 17 17"
    fill="none"
    className={className}
  >
    <path
      d="M13.5 9.375V4.5625C13.5 3.42342 12.5766 2.5 11.4375 2.5H4.5625C3.42342 2.5 2.5 3.42342 2.5 4.5625V11.4375C2.5 12.5766 3.42342 13.5 4.5625 13.5H9.03125M13.5 9.375L9.03125 13.5M13.5 9.375H10.4062C9.64684 9.375 9.03125 9.99059 9.03125 10.75V13.5M5.33333 5.33333H10.6667M5.33333 8H8"
      stroke="currentColor"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default NotesIcon;
